<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-7">
                        <div class="font-weight-bold body-1">
                            Detalles del Producto
                        </div>
                    </v-col>
                </v-row> 
                <v-row justify="center">
                    <v-col cols="12" md="7" >

                    <details-item :detailsItems="items"></details-item>


                    </v-col>
                    
                </v-row>

            </div>
            <v-row justify="center" align="end">
				<v-col cols="12" md="7" class="d-flex justify-end">
                    
					<primary-button :props="cancelBtnData"></primary-button>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import DetailsItem from '../../components/DetailsItem.vue';
import Utils from "../../helpers/Utils";
import {ObjectTaxes} from "./ObjectTaxesValues"
export default {
    components: {
        DetailsItem,
    },
	data(){
		return {
            slug: this.$route.params.slug,
            loading: false,
           
            items: [
               
                
            ],
           
            cancelBtnData: {
                text: "Regresar",
                icon: "",
                to: "Products",	
                click: () => {}
            },
            
         
          
		}
    },
    mounted(){
        this.index();
    },
	methods: {
		validate () {
			return this.$refs.form.validate()
		},
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.product.get(this.$store.state.business, this.slug)
			.then((response) => {
               
                this.items= [
                    { concepto: 'Folio', index: 'folio', valor: response.data.Folio },
                    { concepto: 'Nombre Interno', index: 'folio_int', valor:response.data.Name??""},
                    { concepto: 'Descripción', index: 'date', valor: response.data.Description??'' },
                    { concepto: 'Precio Unitario', index: 'provider.name', valor: Utils.currencyFormat(response.data?.Price??0)},
                    { concepto: 'Clave', index: 'bank_account.name', valor: `${response.data?.CodeProdServ??""} - ${response.data?.NameCodeProdServ??""}`},
                    { concepto: 'Unidad', index: 'payment_method.name', valor: `${response.data?.UnitCode??""} - ${response.data?.Unit??""}` },
                    { concepto: 'Objeto Impuesto', index: 'currency', valor:this.getObjectTax(response.data?.ObjetoImp??"") },
                    { concepto: 'IVA', index: 'slug', valor: `${Utils.getPercentage(response.data?.IVA,1)}%` },
                    { concepto: 'IVA RET', index: 'slug', valor: '-' },
                    { concepto: 'IEPS', index: 'exchange_rate', valor: '-'},
                    { concepto: 'ISR', index: 'folio', valor: '-' },
                   
                ];
                

               
                
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},

        getObjectTax(value) {
            const found = ObjectTaxes.find((x) => x.value == value);
            return found != undefined ? `${found.text}` : value;
        },

       
    },
}
</script>

<style>
    .v-skeleton-loader__text{
        margin-bottom: 0px;
    }
    .pre{
        white-space: pre-line;
    }
</style> 